import React from 'react';
import {Link, Outlet} from "react-router-dom";


const Layout = (props: any) => {

    return (
        <div>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingLeft: '10%', paddingRight: '10%', backgroundColor: '#dfdfdf', paddingTop: 20, paddingBottom: 20}}>

                    <Link to={'/admin/catalog'} className={'mr-9 ml-9  text__white'}>КАТАЛОГ</Link>
                    <Link to={'/admin'} className={'mr-9 text__white'}>Настройки</Link>
                    <Link to={'/admin/karaoke'} className={'mr-9 text__white'}>Караоке</Link>
                    <Link to={'/admin/login'} className={'mr-9 text__white'}>Вход</Link>

            </div>
            <div style={{width: '100%', height: 3, background: '#86BAEA'}}></div>
            <Outlet />
        </div>
    );
};

export default Layout;
